import { render, staticRenderFns } from "./AccountSettingGeneral.vue?vue&type=template&id=8a8a7132"
import script from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
export * from "./AccountSettingGeneral.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingGeneral.vue?vue&type=style&index=0&id=8a8a7132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports